/* SAMPLE COLLECTORS */
// get METHODS
export const GET_METHODS_LIST = "GET_METHODS_LIST";
export const GET_METHODS_LIST_SUCCESS ="GET_METHODS_LIST_SUCCESS";
export const GET_METHODS_LIST_FAIL = "GET_METHODS_LIST_FAIL";
// Add METHODS
export const ADD_NEW_METHODS = "ADD_NEW_METHODS";
export const ADD_NEW_METHODS_SUCCESS = "ADD_NEW_METHODS_SUCCESS";
export const ADD_NEW_METHODS_FAIL = "ADD_NEW_METHODS_FAIL";
//Update METHODS
export const UPDATE_METHODS = "UPDATE_METHODS";
export const UPDATE_METHODS_SUCCESS = "UPDATE_METHODS_SUCCESS";
export const UPDATE_METHODS_FAIL = "UPDATE_METHODS_FAIL";
//delete METHOD
export const DELETE_METHOD = "DELETE_METHOD";
export const DELETE_METHOD_SUCCESS = "DELETE_METHOD_SUCCESS";
export const DELETE_METHOD_FAIL = "DELETE_METHOD_FAIL";

/////methods added by analytes

export const GET_ANALYTESMETHODS_LIST = "GET_ANALYTESMETHODS_LIST_LIST";
export const GET_ANALYTESMETHODS_LIST_SUCCESS ="GET_ANALYTESMETHODS_LIST_SUCCESS";
export const GET_ANALYTESMETHODS_LIST_FAIL = "GET_ANALYTESMETHODS_LIST_FAIL";
// Add units
export const ADD_NEW_ANALYTESMETHODS = "ADD_NEW_ANALYTESMETHODS";
export const ADD_NEW_ANALYTESMETHODS_SUCCESS = "ADD_NEW_ANALYTESMETHODS_SUCCESS";
export const ADD_NEW_ANALYTESMETHODS_FAIL = "ADD_NEW_ANALYTESMETHODS_FAIL";
//Update Units
export const UPDATE_ANALYTESMETHODS = "UPDATE_ANALYTESMETHODS";
export const UPDATE_ANALYTESMETHODS_SUCCESS = "UPDATE_ANALYTESMETHODS_SUCCESS";
export const UPDATE_ANALYTESMETHODS_FAIL = "UPDATE_ANALYTESMETHODS_FAIL";
